import type { TFunction } from "i18next";
import { MultipleChoiceOptionStringId } from "../../../../types/forms/MultipleChoiceOptions";

export type DeclineReasonValue = "NO_FEEDBACK" | "DECLINE" | "WILL_GIVE";

export function buildDeclineOptions(
  t: TFunction
): MultipleChoiceOptionStringId[] {
  return [
    {
      optionId: "NO_FEEDBACK",
      value: "NO_FEEDBACK",
      text: t("Feedback.Decline.DeclineNoFeedback", {
        defaultValue: "I don't have any feedback",
      }),
      isSelected: false,
      allowCustomText: false,
    },
    {
      optionId: "DECLINE",
      value: "DECLINE",
      text: t("Feedback.Decline.DeclineDontWant", {
        defaultValue: "I'd prefer not to give feedback",
      }),
      isSelected: false,
      allowCustomText: false,
    },
    {
      optionId: "WILL_GIVE",
      value: "WILL_GIVE",
      text: t("Feedback.Decline.DeclineWillGive", {
        defaultValue: "Actually, I will give feedback",
      }),
      isSelected: false,
      allowCustomText: false,
    },
  ];
}

export function getSelectedDeclineOption(
  options: MultipleChoiceOptionStringId[]
): MultipleChoiceOptionStringId | undefined {
  return options.find((option) => option.isSelected);
}

export function shouldShowDeclineChoiceNote(
  selectedOption: MultipleChoiceOptionStringId | undefined
): boolean {
  return selectedOption != null && selectedOption.value !== "WILL_GIVE";
}
